//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    type: String,
  },
  inject: {
    prefixClass: {
      default: 'mx',
    },
  },
};
